import React, { ReactNode, useState, useEffect, FC } from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';

type Props = {
  stripeKey?: string;
  children: ReactNode;
};

export const StripePublicKeyContext = React.createContext<string | undefined>(undefined);

const StripeWrapper: FC<Props> = (props: Props) => {
  const { stripeKey, children } = props;
  const [stripe, setStripe] = useState<stripe.Stripe | null>(null);

  useEffect(() => {
    const updateStripe = setInterval(() => {
      if (stripeKey && window.Stripe) {
        setStripe(window.Stripe(stripeKey));
        clearInterval(updateStripe);
      } else if (!!window.Stripe) {
        clearInterval(updateStripe);
      }
    }, 100);
  }, [stripeKey]);

  return (
    <StripePublicKeyContext.Provider value={stripeKey}>
      <StripeProvider stripe={stripe}>
        <Elements>{children}</Elements>
      </StripeProvider>
    </StripePublicKeyContext.Provider>
  );
};

export default StripeWrapper;
